module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.17355/images/engage-ai/engage-ai-mobile-logo.svg"